<template>
  <!-- begin:: Footer -->
  <footer>
            <div class="container">
                <div class="row">

                    <div class="col-6 col-lg-3 col-md-6 sm-margin-30px-bottom">

                        <img alt="footer-logo" src="/media/img/logos/logo-white.png" style="max-height: 70px;">
                        <div class="margin-25px-top footer-social-icons">
                            <ul>
                                <li><a href="https://www.facebook.com/Seguro-x-Kilómetro-100456568362281"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="https://www.instagram.com/seguroporkilometrochile/"><i class="fab fa-instagram"></i></a></li>
                                <!--<li><a href="#!"><i class="fab fa-linkedin-in"></i></a></li>-->
                            </ul>
                        </div>

                    </div>

                    <div class="col-6 col-lg-3 col-md-6 sm-margin-30px-bottom">
                        <h3 class="text-white">Comunícate con Nosotros</h3>
                        <ul class="footer-list">

                            <li>
                                <span class="d-inline-block vertical-align-top font-size18"><i class="far fa-envelope text-theme-color"></i></span>
                                <a href="mailto:info@segurporkilometro.cl"><span class="d-inline-block width-85 vertical-align-top padding-10px-left">info@segurporkilometro.cl</span></a>

                            </li>
                            <li>
                                <span class="d-inline-block vertical-align-top font-size18"><i class="fas fa-mobile-alt text-theme-color"></i></span>
                                <span class="d-inline-block width-85 vertical-align-top padding-10px-left">(+56) 2638 4658</span>
                            </li>
                            <li>
                                <span class="d-inline-block vertical-align-top font-size18"><i class="fab fa-whatsapp text-theme-color"></i></span>
                                <a href="https://api.whatsapp.com/send?phone=56932265306&amp;text=Necesito%20comunicarme%20con%20Uds."> WhatsApp Seguro x Kilómetro</a>
                            </li>
                        </ul>
                    </div>

                    <div class="col-6 col-lg-3 col-md-6 sm-margin-30px-bottom">
                        <h3 class="text-white">Visítanos</h3>
                        <ul class="footer-list">
                            <li>
                                <span class="d-inline-block vertical-align-top font-size18"><i class="fas fa-map-marker-alt text-theme-color"></i></span>
                                <span class="d-inline-block width-85 vertical-align-top padding-10px-left">Av. Andrés Bello 1245 Of.606<br> Providencia-Santiago-Chile</span>
                            </li>
                        </ul>
                    </div>

                    <div class="col-6 col-lg-3 col-md-6 sm-margin-30px-bottom">
                        <h3 class="text-white">Partners:</h3>
                        <a href="http://acoseg.cl/"><img alt="footer-logo" src="/media/img/acoseg.png" style="max-height: 80px;"></a>
                    </div>
                </div>

            </div>
            <div class="footer-bar">
                <div class="container">

                    <div class="row">
                        <div class="col-lg-2 col-md-6 sm-margin-30px-bottom">
                            <a href="https://seguroslascondes.cl/"><img alt="footer-logo" src="/media/img/slc-blanco.png" style="max-height: 70px;"></a>
                        </div>

                        <div class="col-lg-2 col-md-6 sm-margin-30px-bottom">
                            <a href="https://bomberoseguro.cl/"><img alt="footer-logo" src="/media/img/logo-bomberoseguro-blanco.webp.png" style="max-height: 70px;"></a>
                        </div>

                        <div class="col-lg-2 col-md-6 sm-margin-30px-bottom">
                            <a href="https://www.soapbomberos.cl/"><img alt="footer-logo" src="/media/img/soap-bomberos.png" style="max-height: 70px;"></a>
                        </div>

                        <div class="col-lg-6 col-md-6 sm-margin-30px-bottom">
                            <ul class="footer-list">

                                <li>
                                    <a href="docs/TERMINOS-Y-CONDICIONES-DE%20USO-INTERFAZ-SEGURO-X-KM.pdf">
                                        <span class="d-inline-block width-85 vertical-align-top padding-10px-left">TÉRMINOS Y CONDICIONES DE USO INTERFAZ</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="docs/CONDICIONES-DE-MEDIO-DE-PAGO.pdf">
                                        <span class="d-inline-block width-85 vertical-align-top padding-10px-left">CONDICIONES DE MEDIO DE PAGO</span>
                                    </a>

                                </li>
                                <li>
                                    <a href="docs/CONTRATO-DE-COMODATO.pdf">
                                        <span class="d-inline-block width-85 vertical-align-top padding-10px-left">CONTRATO DE COMODATO</span>
                                    </a>

                                </li>
                            </ul>

                        </div>
                    </div>
                    <p style="margin-top: 20px;">
                        &copy;
                        2020 Seguro X Kilómetro - Seguros Las Condes
                    </p>
                </div>
            </div>
        </footer>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
